// extracted by mini-css-extract-plugin
module.exports = {"container":"visual-story-m__container__3hjJ2","cta":"visual-story-m__cta__3BezK","ampIcon":"visual-story-m__ampIcon__3AVQd"};